import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgActiveFalse = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.987 9.263q0-.852-.609-1.458a2 2 0 0 0-1.464-.608q-.26 0-.493.052a1.4 1.4 0 0 0-.44.18l2.772 2.764q.13-.207.182-.44.051-.231.052-.49m4.353 5.5-1.503-1.498q.648-1.084.972-2.026t.324-1.77q0-2.814-1.8-4.608-1.801-1.795-4.42-1.795-1.14 0-2.137.349a5.8 5.8 0 0 0-1.801 1.02L7.498 2.961a8 8 0 0 1 2.513-1.458A8.5 8.5 0 0 1 12.914 1q3.29 0 5.792 2.298 2.5 2.299 2.5 6.171 0 1.24-.467 2.544-.465 1.305-1.399 2.75m-4.068 1.833L6.798 8.153q-.051.309-.078.645a9 9 0 0 0-.026.671q0 1.834 1.53 4.197 1.528 2.364 4.69 5.254.674-.594 1.257-1.174.584-.58 1.1-1.15M21.698 23l-4.975-4.958q-.83.878-1.762 1.782a37 37 0 0 1-2.047 1.833q-4.173-3.538-6.232-6.57-2.06-3.034-2.06-5.618 0-.825.129-1.575.129-.748.363-1.42L1.175 2.55l1.477-1.472 20.523 20.451z"
      />
    </svg>
  );
};
export default SvgActiveFalse;
